function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#stock-control_svg__clip0_11331_29216)",
  stroke: "#4D4D4D",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.686 42.28h-37.2a1.2 1.2 0 00-1.2 1.2v25.2a1.2 1.2 0 001.2 1.2h37.2a1.2 1.2 0 001.2-1.2v-25.2a1.2 1.2 0 00-1.2-1.2z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.608 42.713l-6.027-7.214a1.185 1.185 0 00-.896-.418h-25.2a1.18 1.18 0 00-.894.418l-6.029 7.214M21.085 65.08a9 9 0 100-18 9 9 0 000 18z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.398 55.993l3.088 3.088 5.513-5.513",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.743 67.823l15.51-39.153a1.2 1.2 0 00.09-.447c0-.525-.342-.959-.813-1.122l-3.63-1.206a1.192 1.192 0 00-.357-.072 1.2 1.2 0 00-1.11.747l-15.69 38.853 1.2 4.8 4.8-2.4z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.445 32.918l-5.789-2.173",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.566 25.146l2.827 1.632 2.914-5.047",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.233 13.816l-4.001 1.073a1 1 0 00-.708 1.224l5.014 18.71M48.555 6.497l4.002-1.073a1 1 0 011.225.707l7.171 26.765m2.584 9.643l3.038 11.337a1 1 0 01-.707 1.224l-7.196 1.929m-8.303 2.224l-9.31 2.495"
}), /*#__PURE__*/React.createElement("rect", {
  x: 20.568,
  y: 11.332,
  width: 28.286,
  height: 7.714,
  rx: 1,
  transform: "rotate(-15 20.568 11.332)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M25.445 24.704l26.149-7.006M26.776 29.672l13.73-3.679"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 19.4V22M10.5 25.8v2.6M10.5 14.2v1.4M63.5 14v2.6M63.5 8.8v1.4",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "stock-control_svg__clip0_11331_29216"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h72v72H0z"
})));

function SvgStockControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/stock-control.svg";
export { SvgStockControl as ReactComponent };